import React, { useState, useEffect } from 'react';
import { TextField, Button, Typography, Box, Grid, useTheme, Paper } from '@mui/material';
import { purple, teal } from '@mui/material/colors';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { CloudUpload } from '@mui/icons-material';
import axios from "../../../lib/axios";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import ConfirmationDialog from '../../ReusableDailog';
import CrudButtons from '../../../GlobalFunction/CrudButtons';
import DescriptionIcon from '@mui/icons-material/Description';
import BroadcastOnHomeIcon from '@mui/icons-material/BroadcastOnHome';

function Broadcast() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        BrdCastNo: '',
        BrdCastDt: '',
        BrdCastTitle: '',
        BrdCastSubj: '',
        BrdCastDesc: '',
        Attachment: '',
        ImgName: '',
        Status: '',
        CreatedBy: '1',
    });
    const theme = useTheme();
    const [UserId, setUserId] = useState(sessionStorage.getItem('UserId'));
    const [isFormDisabled, setIsFormDisabled] = useState(true);
    const [location, setLocation] = useState(useLocation());
    const [currentBrdCastID, setCurrentBrdCastID] = useState(null);
    const [PropertyDrp, setPropertyDrp] = useState([]);
    const [mode, setMode] = useState('view');
    const [Status, setStatus] = useState("1");
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [ImgName, setImgName] = useState(null);
    const [Attachment, setAttachment] = useState(null);
    const [currentPropertyId, setCurrentPropertyId] = useState(null);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [fileName, setFileName] = useState("");
    const [fileType, setFileType] = useState("");
    const [date, setDate] = useState(dayjs());

    useEffect(() => {
        if (location.state && location.state.BrdCastId) {
            setCurrentBrdCastID(location.state.BrdCastId);
            fetchCastData(location.state.BrdCastId);
            setMode('view');
        } else {
            setMode('add');
            setIsFormDisabled(false);
            const currentDate = dayjs();
            setDate(currentDate);
            setFormData(prevState => ({
                ...prevState,
                BrdCastDt: currentDate.format("YYYY-MM-DD")
            }));
        }
    }, [location]);

    const formatDate = (dateStr) => {
        if (!dateStr) return "";

        const date = new Date(dateStr);
        if (isNaN(date)) return "";

        return date.toISOString().split("T")[0];
    };

    const fetchCastData = async (id, flag) => {
        try {
            const response = await axios.post('MstBrdCast/RetriveMstBrdCast', {
                BrdCastId: parseInt(id),
                Flag: flag
            });

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                const brdCastData = response.data.Data[0];
                const fixedImageUrl = brdCastData.Attachment.startsWith('http:/')
                    ? brdCastData.Attachment.replace('http:/', 'http://')
                    : brdCastData.Attachment;
                setFormData({
                    BrdCastNo: brdCastData.BrdCastNo,
                    BrdCastDt: formatDate(brdCastData.BrdCastDt),
                    BrdCastTitle: brdCastData.BrdCastTitle,
                    BrdCastSubj: brdCastData.BrdCastSubj,
                    BrdCastDesc: brdCastData.BrdCastDesc,
                    ImgName: brdCastData.ImgName,
                    Attachment: fixedImageUrl,
                    BrdCastId: brdCastData.BrdCastId
                });
                setDate(dayjs(brdCastData.BrdCastDt));
                setIsFormDisabled(true);
                setCurrentBrdCastID(brdCastData.BrdCastId);
            }
        } catch (error) {
            // toast.error('Error fetching data. Please try again.');
        }
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const InputChange = (value, delta, source, editor) => {
        setFormData(prevState => ({
            ...prevState,
            BrdCastDesc: value,
            BrdCastDesc_text: editor.getText().trim()
        }));
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();

            reader.onloadend = () => {
                const base64String = reader.result;

                setFormData((prev) => ({
                    ...prev,
                    Attachment: base64String, // Set the base64 string of the file
                    ImgName: file.name, // Set the image name as the file name
                }));
                setFileName(file.name);  // Optionally save file name separately
                setFileType(file.type);  // Optionally save file type separately
            };
            reader.readAsDataURL(file);  // Read the file as a base64 string
        }
    };

    const handleSave = () => {
        setOpenConfirmDialog(false);
    };

    const handleSubmit = async () => {
        try {
            const fileName = formData.ImgName ? formData.ImgName : '';
            const payload = {
                BrdCastId: currentBrdCastID ? parseInt(currentBrdCastID) : 0,
                BrdCastNo: formData.BrdCastNo || '',
                BrdCastTitle: formData.BrdCastTitle || '',
                BrdCastSubj: formData.BrdCastSubj || '',
                BrdCastDesc: formData.BrdCastDesc || '',
                BrdCastDt: formData.BrdCastDt || '',
                Attachment: formData.Attachment || '',
                ImgName: fileName || '',
                Status: Status,
                CreatedBy: '1',
            };

            let response;

            if (mode === 'edit') {
                payload.BrdCastId = currentBrdCastID;
                payload.UpdatedBy = parseInt(UserId, 10);
                response = await axios.post(`MstBrdCast/UpdateMstBrdCast`, payload);
            } else {
                payload.CreatedBy = parseInt(UserId, 10);
                response = await axios.post(`MstBrdCast/InsertMstBrdCast`, payload);
            }

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                toast.success(response.data.Message);

                if (mode === 'add') {
                    const newCastId = response.data.Data;
                    setCurrentBrdCastID(newCastId);
                    setMode('view');
                    setIsFormDisabled(true);
                    await fetchCastData(newCastId);
                } else {
                    setMode('view');
                    setIsFormDisabled(true);
                }
            } else {
                toast.error(response.data.Message || 'Operation failed');
            }
        } catch (error) {
            toast.error('Error saving/updating Data. Please try again.');
        }
    };

    const handleDeleteConfirm = async () => {
        try {
            if (!currentBrdCastID || !UserId) {
                toast.warn("Invalid cast ID or user ID.");
                return;
            }
            const response = await axios.post('MstBrdCast/DeleteMstBrdCast', {
                BrdCastId: currentBrdCastID,
                ActionBy: UserId,
            });

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                toast.success(response.data.Message || "Broadcast deleted successfully.");
                await fetchCastData(currentBrdCastID, "P");
            }
        } catch (error) {
            toast.error("Error while deleting the record. Please try again.");
        }
        setOpenDelete(false);
    };

    const handleDeleteClick = () => {
        setOpenDelete(true);
    };

    const handleDeleteCancel = () => {
        setOpenDelete(false);
    };

    const handleHostel = () => {
        setOpenConfirmDialog(true);
    };

    const handleAdd = () => {
        setMode('add');
        setIsFormDisabled(false);
        setCurrentBrdCastID(null);
        setSelectedOptions([]);
        setDate(dayjs());
        setFormData({
            BrdCastNo: '',
            BrdCastDt: dayjs().format("YYYY-MM-DD"),
            BrdCastSubj: '',
            BrdCastDesc: '',
            Attachment: '',
            ImgName: '',
        });
    };

    const handleEdit = () => {
        if (!currentBrdCastID) {
            toast.warn("No broadcast selected to edit");
            return;
        }
        setMode('edit');
        setIsFormDisabled(false);
    };

    const handleCancel = async () => {
        try {
            await fetchCastData(1, "L");
            setStatus("1");
            setMode("view");
            setIsFormDisabled(true);
        } catch (error) {
            toast.error("Error while canceling.");
        }
    };

    const handlePrint = () => {
        toast.warn("Working on updates");
        window.print();
    };

    const handleExit = () => {
        navigate('/broadcasttable');
    };

    const closeConfirmation = () => {
        setOpenConfirmDialog(false);
    };

    return (
        <>
            <Box sx={{ maxWidth: 'lg', margin: '0 auto', padding: 1, mt: 4 }}>
                <ToastContainer />
                <Paper sx={{ padding: 3, borderRadius: 2, boxShadow: 10 }}>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: 1,
                            flexDirection: { xs: 'column', sm: 'row' },
                        }}
                    >
                        <Typography
                            variant="h4"
                            sx={{
                                fontWeight: '100',
                                background: 'linear-gradient(45deg, #6a1b9a, #ff4081, #3f51b5, #635bff)',
                                WebkitBackgroundClip: 'text',
                                backgroundClip: 'text',
                                color: 'transparent',
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            <BroadcastOnHomeIcon sx={{ mr: 1, color: "rgba(207, 46, 100, 1)" }} />
                            Broadcast
                        </Typography>

                        <CrudButtons
                            moduleName={"BroadCast Master"}
                            mode={mode}
                            onAdd={handleAdd}
                            onEdit={handleEdit}
                            onView={handlePrint}
                            onDelete={() => setOpenDelete(true)}
                            onExit={handleExit}
                            readOnlyMode={isFormDisabled}
                            sx={{ marginTop: { xs: 2, sm: 0 } }}
                        />
                    </Box>

                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <TextField
                                id="BrdCastNo"
                                name="BrdCastNo"
                                label="Broadcast No"
                                variant="filled"
                                fullWidth
                                className="custom-textfield"
                                value={formData.BrdCastNo}
                                onChange={handleInputChange}
                                disabled={true}
                            />
                        </Grid>

                        {/* Board Date */}
                        <Grid item xs={12} md={6}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label="Date"
                                    value={date}
                                    disabled={isFormDisabled}
                                    onChange={(newDate) => {
                                        setDate(newDate);
                                        setFormData(prevState => ({
                                            ...prevState,
                                            BrdCastDt: newDate.format("YYYY-MM-DD")
                                        }));
                                    }}
                                    slotProps={{ textField: { size: 'small', fullWidth: true, }, }}
                                    format="DD/MM/YYYY"
                                />
                            </LocalizationProvider>
                        </Grid>

                        {/* Board Subject */}
                        <Grid item xs={12} md={6}>
                            <TextField
                                id="BrdCastTitle"
                                name="BrdCastTitle"
                                label="Title"
                                variant="filled"
                                fullWidth
                                className="custom-textfield"
                                value={formData.BrdCastTitle}
                                disabled={isFormDisabled}
                                onChange={handleInputChange}
                                color="primary"
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                id="BrdCastSubj"
                                name="BrdCastSubj"
                                label="Subject"
                                variant="filled"
                                fullWidth
                                className="custom-textfield"
                                value={formData.BrdCastSubj}
                                disabled={isFormDisabled}
                                onChange={handleInputChange}
                                color="primary"
                            />
                        </Grid>

                        {/* Board Description */}
                        <Grid item xs={12} md={9}>
                            <Typography variant="h6" color={purple[600]} gutterBottom>
                                Description
                            </Typography>
                            <ReactQuill
                                id="BrdCastDesc"
                                name="BrdCastDesc"
                                variant="filled"
                                fullWidth
                                disabled={isFormDisabled}
                                className="custom-textfield"
                                value={formData.BrdCastDesc}
                                onChange={InputChange}
                                theme="snow"
                                style={{
                                    height: '190px',
                                    borderRadius: '8px',
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} md={3} mt={6}>
                            <Box
                                sx={{
                                    marginTop: { xs: 3, md: 0 },
                                    width: 250,
                                    height: 220,
                                    border: '1px solid #080000ff',
                                    borderRadius: '10px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: '#f9f9f9',
                                    boxShadow: 1,
                                    overflow: 'hidden',
                                    position: 'relative',
                                }}
                            >
                                {formData.Attachment ? (
                                    fileType === 'application/pdf' || formData.ImgName?.toLowerCase().endsWith('.pdf') ? (
                                        <Box
                                            sx={{
                                                textAlign: 'center',
                                                p: 2,
                                                cursor: 'pointer',
                                                '&:hover': { backgroundColor: '#f0f0f0' },
                                                borderRadius: '8px',
                                            }}
                                            onClick={() => window.open(formData.Attachment, '_blank')}
                                        >
                                            <DescriptionIcon sx={{ fontSize: 50, color: '#d32f2f' }} />
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    mt: 1,
                                                    fontWeight: 'bold',
                                                    wordBreak: 'break-all',
                                                    color: '#d32f2f',
                                                }}
                                            >
                                                {formData.ImgName || 'PDF File'}
                                            </Typography>
                                            <Typography variant="caption" color="text.secondary">
                                                Click to open
                                            </Typography>
                                        </Box>
                                    ) : (
                                        <img
                                            alt="preview"
                                            src={formData.Attachment}
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'cover',
                                                borderRadius: '8px',
                                            }}
                                            onClick={() => window.open(formData.Attachment, '_blank')}
                                            title="Click to view full size"
                                        />
                                    )
                                ) : (
                                    <Typography variant="body2" color="textSecondary">
                                        No Attachment
                                    </Typography>
                                )}
                            </Box>
                        </Grid>

                        <Grid item xs={12} md={12}>
                            <Box sx={{ display: 'flex', justifyContent: { xs: 'flex-start', md: 'flex-end' }, alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                                <Button
                                    variant="contained"
                                    component="label"
                                    disabled={isFormDisabled}
                                    startIcon={<CloudUpload />}
                                    sx={{
                                        backgroundColor: teal[600],
                                        color: 'white',
                                        '&:hover': { backgroundColor: teal[700] },
                                        padding: '7px 10px',
                                        borderRadius: '8px',
                                        textTransform: 'none',
                                        boxShadow: 2,
                                    }}
                                >
                                    Attachment
                                    <input
                                        type="file"
                                        hidden
                                        accept=".pdf,.jpeg,.jpg,.xlsx,.png"
                                        onChange={handleFileChange}
                                    />
                                </Button>

                                {mode === 'view' && (
                                    <>
                                        <Button variant='contained' sx={{ background: 'linear-gradient(290deg, #d4d4d4, #ffffff)' }} onClick={handleAdd} disabled>
                                            Submit
                                        </Button>
                                        <Button variant='contained' sx={{ background: 'linear-gradient(290deg, #a7c5e9, #ffffff)' }} onClick={handleEdit} disabled>
                                            Cancel
                                        </Button>
                                    </>
                                )}

                                {(mode === 'add' || mode === 'edit') && (
                                    <>
                                        <Button
                                            variant="contained"
                                            onClick={handleSubmit}
                                            sx={{
                                                backgroundColor: '#635bff',
                                                '&:hover': { backgroundColor: '#453cf5' },
                                                boxShadow: 2,
                                            }}
                                        >
                                            Submit
                                        </Button>
                                        <Button
                                            variant="outlined"
                                            onClick={handleCancel}
                                            sx={{
                                                borderColor: '#635bff',
                                                color: '#635bff',
                                                '&:hover': {
                                                    borderColor: '#453cf5',
                                                    color: '#453cf5',
                                                    backgroundColor: 'rgba(99, 91, 255, 0.04)',
                                                },
                                                boxShadow: 2,
                                            }}
                                        >
                                            Cancel
                                        </Button>
                                    </>
                                )}
                            </Box>
                        </Grid>
                    </Grid>
                </Paper>
                <ConfirmationDialog
                    open={openDelete}
                    onClose={handleDeleteCancel}
                    onConfirm={handleDeleteConfirm}
                    title="Confirm Deletion"
                    message="Are you sure you want to delete this broadcast?"
                />
            </Box>
        </>
    );
}

export default Broadcast;